// Constants.
import * as LMSConstants from 'constants/LMSConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  material: {},
  errorMessage: '',
  ...window.__initialState__?.lmsMaterial ?? {},
};

export default function lmsCourseMaterial(state = initialState, action = {}) {
  switch (action.type) {
    case LMSConstants.LOAD_LMS_COURSE_MATERIAL_REQUEST:
      return {
        ...state,
        material: {},
        isFetched: false,
        isFetching: true,
      };
    case LMSConstants.LOAD_LMS_COURSE_MATERIAL_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        material: action.material,
      };
    case LMSConstants.LOAD_LMS_COURSE_MATERIAL_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        material: {},
        errorMessage: action.message,
      };
    case LMSConstants.UPDATE_LMS_COURSE_MATERIAL_REQUEST:
      return {
        ...state,
        material: action.material,
      };
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        materials: {},
        errorMessage: '',
      };
    default:
      return state;
  }
}
